<template>
  <div class="app-cost-summary">
    <slot name="txtBefore"><h2>Übersicht der Kosten</h2></slot>
    <div class="summary-data-costs">
      <b-row class="data-line thead">
        <b-col md="" sm="" class="data-cell first">
          <slot name="txtOptionsHeader">Ausgewählte Optionen</slot>
        </b-col>
        <b-col md="" sm="" class="data-cell second">
          <slot name="txtCosts">Monatliche Kosten</slot>
        </b-col>
        <b-col md="" sm="" class="data-cell third">
          <slot name="txtDuration">Laufzeit</slot>
        </b-col>
      </b-row>
    </div>
    <div class="data-block-options" v-for="item in options" :key="item.id">
      <b-row class="data-line opts">
        <b-col md="" sm="" class="data-cell first name">
          <div>
            <span v-html="item.name"></span>
            <span v-if="item.extraHtml" v-html="item.extraHtml"></span>
          </div>
          <div class="option-info">
            <p v-if="item.info">{{ item.info }}</p>
          </div>
        </b-col>
        <b-col md="" sm="" class="data-cell second price">
          <span v-if="item.price !== 0">{{ price(item.price) }}</span>
          <span v-if="item.price === 0">
            <slot name="txtForFree">kostenlos</slot>
          </span>
        </b-col>
        <b-col md="" sm="" class="data-cell third duration">
          <span v-if="item.duration">{{ item.duration.amount }} {{ durationUnit(item.duration.unit, item.duration.amount) }}</span>
          <span v-else><slot name="txtNoDuration">unbefristet</slot></span>
        </b-col>
      </b-row>
    </div>
    <div class="data-block-sum">
    <b-row class="data-line summe">
      <b-col md="" sm="" class="data-cell first">
        <slot name="txtSum">Summe: </slot>
      </b-col>
      <b-col md="" sm="" class="data-cell second">{{ price(sum) }}</b-col>
    </b-row>
    </div>
    <div class="data-block-dokument-url" v-if="urlContract !== null && isAutomaticExtension">
      <b-row class="data-line">
        <b-col md="" sm="">
          <p>Die Vertragszusammenfassung finden Sie <a class="pdf-download" @click="downloadPdf">hier</a>.</p>
        </b-col>
      </b-row>
    </div>
    <Stepper
      :show-prev="true"
      @prev="prev"
      @next="next"
      :loading-next="loading"
    >
      <template v-if="!isDeactivate" #btnNext><slot name="btnNext">buchen</slot></template>
      <template v-else #btnNext><slot name="btnNextDeactivate">Kündigen</slot></template>
    </Stepper>
  </div>
</template>

<script>

import price from '../../../../../mixins/price'
import durationUnit from '../../../../../mixins/durationUnit'
import Stepper from '../../../../generic/Stepper.vue'
import processSteps from '@/mixins/processSteps'
import { stepName as successStep } from './ServiceOptions/Success.vue'
import { stepName as selectStep } from './Select.vue'
import { mapGetters } from 'vuex'
import FileSaver from 'file-saver'
import axios from 'axios'

export const stepName = 'summary'
export default {
  name: 'OptionsSummary',
  components: { Stepper },
  computed: {
    ...mapGetters('bookTariffOptions', [
      'bookTariffoptionDocumentUrl'
    ]),
    ...mapGetters([
      'accessToken'
    ]),
    urlContract: function () {
      return this.bookTariffoptionDocumentUrl
    },
    sum: function () {
      let sum = 0
      this.options.forEach(function (item) {
        if (('price' in item)) {
          sum = sum + item.price
        }
      })
      return sum
    }
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    isAutomaticExtension: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    isDeactivate: {
      type: Boolean,
      default: false
    }
  },
  mixins: [
    price,
    durationUnit,
    processSteps(stepName, selectStep, successStep)
  ],
  methods: {
    next () {
      if (this.isDeactivate) {
        this.$emit('cancel-option', this.nextStep)
      } else {
        this.$emit('save-options', this.nextStep)
      }
    },
    prev () {
      this.$emit('update-step', this.previousStep)
    },
    downloadPdf () {
      const me = this
      axios.get(this.urlContract, {
        baseURL: this.$config.apiUrl || '',
        headers: {
          Authorization: `Bearer ${this.accessToken}`,
          Accept: 'application/pdf'
        },
        responseType: 'blob'
      }).then((response) => {
        const file = new Blob([response.data], { type: response.headers['content-type'] })
        FileSaver.saveAs(file, 'Vertragszusammenfassung.pdf')
      }).catch((reason) => {
        me.$store.commit('addError', 'Fehler beim Abrufen der Datei. (' + reason.response.status + ')')
      })
    }
  }
}
</script>
